import { render } from "./TreatDetail.vue?vue&type=template&id=4c219cee"
import script from "./TreatDetail.vue?vue&type=script&lang=js"
export * from "./TreatDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__